import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Bump when publishing new dictionary keys so browsers do not reuse older JSON files.
export const TRANSLATIONS_VERSION = '20260903-driver-camera-1';

export function createTranslationLoader(http: HttpClient, prefix: string): TranslateHttpLoader {
  return new TranslateHttpLoader(http, prefix, '.json?v=' + TRANSLATIONS_VERSION);
}
